import HeroBanner from './HeroBanner';
import type { TextType, ButtonType, HeroBannerProps } from './HeroBanner';

export type { TextType, ButtonType, HeroBannerProps };
export default HeroBanner;
